import type { RouteObject } from 'react-router-dom';

import { transformElegantRoutesToReactRoutes } from '../common/transform.tsx';

export function getReactRoutes(route: any[]) {
  return transformElegantRoutesToReactRoutes(route);
}

/**
 * 过滤路由并收集需要权限的路由
 *
 * @param {Array} routes - 当前路由数组
 * @param {Object | null} parent - 当前节点的父路由，根节点时为 null
 * @param {Array} authRoutes - 用于记录需要权限的路由和对应父级的数组
 * @returns {Array} 返回过滤后的路由数组
 */
export function filterRoutes(
  routes: RouteObject[],
  authRoutes: Router.SingleAuthRoute[] = [],
  cacheRoutes: string[] = []
) {
  return routes.reduce((acc, route) => {
    const newRoute = { ...route };

    if (newRoute.handle?.keepAlive) {
      cacheRoutes.push(route.path || '');
    }

    // 递归处理子路由：注意，此处传递当前路由作为父级
    if (newRoute.children && newRoute.children.length > 0) {
      newRoute.children = filterRoutes(newRoute.children, authRoutes, cacheRoutes);
    }

    // 放入结果数组

    acc.push(newRoute);

    // 如果没有权限，则该路由不加入结果数组
    return acc;
  }, [] as RouteObject[]);
}
